/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Password_PlaceholderInputs */

const vi_einvoice_credential_password_placeholder = /** @type {(inputs: Einvoice_Credential_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập mật khẩu meInvoice`)
};

/**

* @param {Einvoice_Credential_Password_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_password_placeholder = /** @type {((inputs?: Einvoice_Credential_Password_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Password_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_password_placeholder(inputs)
});